export enum UtmQueryParameter {
  CAMPAIGN = 'utm_campaign',
  SOURCE = 'utm_source',
}
